import { config } from '../config';

/**
 * 保存对象(名称,值,参数)
 * @param {*} name 名称
 * @param {*} jsonObj 内容json对象
 * @param {object} opts 参数{maxAge:'过期以分钟数',path:'子目录访问权限',domain:'访问域',secure:'仅用于 https 传输'}
 */
const setJson = (name, jsonObj, opts) => {
  return setItem(name, JSON.stringify(jsonObj), opts);
};

/**
 * 获取cookie 指定内容名称
 * @param {*} name 子项名,为空取出对象
 */
const getJson = (name) => {
  let _value = getItem(name);
  console.log('getJson', _value);
  if (_value) {
    return JSON.parse(_value);
  } else {
    return null;
  }
};

/**
 * 保存对象(名称,值,参数)
 * encodeURIComponent 转码
 * @param {*} name 名称
 * @param {*} value 内容
 * @param {object} opts 参数{maxAge:'过期以分钟数',path:'子目录访问权限',domain:'访问域',secure:'仅用于 https 传输'}
 */
const setItem = (name, value, opts) => {
  opts = opts || {};
  opts.maxAge = opts.maxAge || config.cookie.maxAgeMinute || 43200;
  opts.maxAge = opts.maxAge * 60;

  if (name && value) {
    // 存储进行编码转换
    let _cookie = encodeURIComponent(name) + '=' + encodeURIComponent(value);

    opts.path = opts.path || '/';
    _cookie += ';path=' + opts.path; //cookie 子目录访问权限
    _cookie += ';max-age=' + opts.maxAge; //cookie生命周期  以秒为单位

    if (opts.domain) {
      _cookie += ';domain=' + opts.domain; //访问域
    }
    if (opts.secure) {
      _cookie += ';secure'; //仅用于 https 传输
    }

    _cookie += ';SameSite=Lax';

    document.cookie = _cookie;
    return _cookie;
  } else {
    //throw 'cookie.setObj：' + name+''+value;
    return null;
  }
};

/**
 * 获取cookie 全部对象
 * @param {*} name 存储名
 */
const getItem = (name) => {
  let _cookie = document.cookie;
  // console.log('cookie.getObj' + _cookie)
  let _resp = null;
  if (_cookie) {
    /********* 规范必须保留;号空格*/
    let objs = _cookie.split('; ');
    // console.log('cookie.getObj' + objs.length)
    for (let i = 0, len = objs.length; i < len; i++) {
      let index = objs[i].indexOf('='),
        _name = objs[i].substring(0, index),
        _value = objs[i].substring(index + 1, objs[i].length + index + 1);
      //名称与内容解码
      _name = decodeURIComponent(_name);
      if (_name == name) {
        _resp = decodeURIComponent(_value);
        break;
      }
    }
  }

  return _resp;
};

/**
 * 移除cookie
 * @param {*} name 存储值名
 * @param {*} encode 是否需要解码
 */
const removeItem = (name, encode = true) => {
  if (encode) {
    name = encodeURIComponent(name);
  }

  let _objs = keys();

  // console.log('del', name, _objs);
  if (_objs && _objs.indexOf(name) > -1) {
    //删除全局的
    document.cookie =
      name +
      '=;expire=' +
      new Date('1900/0/0 00:00:00').toGMTString() +
      ';max-age=0;path=/';
    document.cookie =
      name +
      '=; expire=' +
      new Date('1900/0/0 00:00:00').toGMTString() +
      '; max-age=0';

    //  console.log('del:' + name);

    return true;
  } else {
    //  console.log('de:' + _objs[name]);
    return false;
  }
};

/**
 * 清除cookie所有对象
 */
const clear = () => {
  let strCookie = document.cookie;
  /**************   规范必须保留;号空格*/
  let arrCookie = strCookie.split('; ');
  // 将多cookie切割为多个名/值对
  for (let i = 0; i < arrCookie.length; i++) {
    // 遍历cookie数组，处理每个cookie对
    let arr = arrCookie[i].split('=');
    if (arr.length > 0) {
      removeItem(arr[0], false);
    }
  }
  return true;
};

/**
 * 取出所有内容
 * @returns json格式
 */
const all = () => {
  let _cookie = document.cookie;
  // console.log('cookie.getObj' + _cookie)
  let _resp = {};
  if (_cookie) {
    /********* 规范必须保留;号空格*/
    let objs = _cookie.split('; ');
    // console.log('cookie.getObj' + objs.length)
    for (let i = 0, len = objs.length; i < len; i++) {
      let index = objs[i].indexOf('='),
        _name = objs[i].substring(0, index),
        _value = objs[i].substring(index + 1, objs[i].length + index + 1);
      //名称与内容解码
      _name = decodeURIComponent(_name);
      _resp[_name] = decodeURIComponent(_value);
    }
  }
  return _resp;
};

/**
 * 是否存在缓存名
 * @param {*} key 键名
 * @returns
 */
const isKey = (key) => {
  let res = false;
  let strCookie = document.cookie;
  let arr = strCookie.split('; ');
  // 将多cookie切割为多个名/值对
  for (let i = 0; i < arr.length; i++) {
    // 遍历cookie数组，处理每个cookie对
    let _item = arr[i].split('=');
    if (_item.length > 0) {
      let _name = decodeURIComponent(_item[0]);
      if (_name == key) {
        res = true;
        break;
      }
    }
  }
  return res;
};

/**
 * 取出所有缓存的名称
 * cookie的存储空间为4k
 */
const keys = () => {
  let res = [];
  let strCookie = document.cookie;
  let arr = strCookie.split('; ');
  // 将多cookie切割为多个名/值对
  for (let i = 0; i < arr.length; i++) {
    // 遍历cookie数组，处理每个cookie对
    let _item = arr[i].split('=');
    if (_item.length > 0) {
      let _name = decodeURIComponent(_item[0]);
      res.push(_name);
    }
  }
  return res;
};

export {
  setJson,
  getJson,
  setItem,
  getItem,
  removeItem,
  clear,
  all,
  keys,
  isKey
};
